import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptor';
import { extractErrorMessage } from '../utils/errorHandler';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup auth interceptors (includes token refresh on 401)
setupAuthInterceptors(apiClient, 'Stocks');

export const getStocks = async () => {
  try {
    const response = await apiClient.get('/stocks/');
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const getStockById = async (id) => {
  try {
    const response = await apiClient.get(`/stocks/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const createStock = async (data) => {
  try {
    const response = await apiClient.post('/stocks/', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStock = async (id, data) => {
  try {
    const response = await apiClient.patch(`/stocks/${id}/`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStock = async (id) => {
  try {
    const response = await apiClient.delete(`/stocks/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};
